import uniqueId from 'lodash.uniqueid';
import {COUNTRY} from 'front-onceforall-core/dist/utils/country';
import {VAT_IDENTIFICATION_NUMBER_CODE, GROUP_NUMBER_CODE} from 'front-onceforall-core/dist/utils/organisations';
import {ACTRADIS_MASTER_PLATFORM} from '../../utils/constant';

const organisationsInDb = [{
  organisationId: 1,
  country: COUNTRY.FRANCE,
  fullName: 'Organisation 1',
  registrationNumber: '12345678901234',
  groupId: 1,
  businessLine: 'CONSTRUCTION',
  address: {
    addressLine: '50, rue de l\'oie',
    postCode: '69300',
    city: 'Lyon'
  },
  depositor: true,
  mandateService: true,
  status: true,
  dossierState: 'VALID',
  creationDate: '2018-03-01T10:15:30.00Z',
  identificationNumbers: {
    [GROUP_NUMBER_CODE]: '123456789',
    [VAT_IDENTIFICATION_NUMBER_CODE]: 'FR12345678944'
  },
  enabled: true,
  deactivationReason: null,
  remote: false,
  planSelected: false
}, {
  organisationId: 10,
  country: COUNTRY.GERMANY,
  fullName: 'ALG',
  registrationNumber: '52773773',
  groupId: 10,
  businessLine: 'OTHER',
  address: {
    addressLine: '20, boulevard eugène deruelle',
    postCode: '69003',
    city: 'Lyon'
  },
  depositor: true,
  mandateService: false,
  status: false,
  dossierState: 'VALID',
  creationDate: '2018-03-03T10:15:30.00Z',
  identificationNumbers: {},
  enabled: true,
  deactivationReason: null,
  remote: false,
  planSelected: true
}, {
  organisationId: 3,
  country: COUNTRY.GERMANY,
  fullName: 'ILG',
  registrationNumber: '50320789',
  groupId: 3,
  businessLine: 'OTHER',
  address: {
    addressLine: '20, boulevard eugène deruelle',
    postCode: '69003',
    city: 'Lyon'
  },
  depositor: true,
  mandateService: true,
  status: true,
  dossierState: 'VALID',
  creationDate: '2018-08-11T10:15:30.00Z',
  identificationNumbers: {},
  enabled: true,
  deactivationReason: null,
  remote: false,
  planSelected: true,
  website: 'https://www.infolegale.fr'
}, {
  organisationId: 2,
  country: COUNTRY.GERMANY,
  fullName: 'D&S',
  registrationNumber: '12345679',
  groupId: 2,
  interoperatedOrganisation: {
    country: COUNTRY.FRANCE,
    enabled: true,
    masterPlatform: ACTRADIS_MASTER_PLATFORM
  },
  businessLine: 'OTHER',
  address: {
    addressLine: 'BrahmStrasse 10',
    postCode: '69300',
    city: 'Lindau'
  },
  identificationNumbers: {
    [VAT_IDENTIFICATION_NUMBER_CODE]: '813349993'
  },
  depositor: false,
  mandateService: false,
  status: true,
  dossierState: 'VALID',
  creationDate: '2018-10-04T10:15:30.00Z',
  enabled: true,
  deactivationReason: null,
  remote: false,
  planSelected: true
}, {
  organisationId: 4,
  country: COUNTRY.GERMANY,
  fullName: 'MAITRISE ASSISTANCE TECHNIQUE ETUDE CONCEPTION M.A.T.E.C.',
  registrationNumber: '34567812',
  groupId: 4,
  businessLine: 'CONSTRUCTION',
  address: {
    addressLine: 'BrahmStrasse 9',
    postCode: '69300',
    city: 'Lindau'
  },
  depositor: true,
  mandateService: false,
  status: false,
  dossierState: 'VALID',
  creationDate: '2018-05-07T10:15:30.00Z',
  identificationNumbers: {},
  enabled: true,
  deactivationReason: null,
  remote: false,
  planSelected: true
}, {
  organisationId: 5,
  country: COUNTRY.FRANCE,
  fullName: 'COLAS',
  registrationNumber: '81334851300017',
  groupId: 5,
  businessLine: 'CONSTRUCTION',
  address: {
    addressLine: '89 rue du coq',
    postCode: '45600',
    city: 'Sully sur Loire'
  },
  identificationNumbers: {
    [GROUP_NUMBER_CODE]: '813348513'
  },
  depositor: false,
  mandateService: false,
  status: true,
  dossierState: 'VALID',
  creationDate: '2018-05-07T10:15:30.00Z',
  enabled: true,
  deactivationReason: null,
  remote: false,
  planSelected: true
}, {
  organisationId: 6,
  country: COUNTRY.FRANCE,
  fullName: 'Bouygues Immobilier',
  registrationNumber: '56209154601009',
  groupId: 6,
  businessLine: 'CONSTRUCTION',
  address: {
    addressLine: '3 boulevard Gallieni',
    postCode: '92130',
    city: 'Issy les moulineaux'
  },
  identificationNumbers: {},
  depositor: true,
  mandateService: true,
  status: true,
  dossierState: 'VALID',
  creationDate: '2018-05-07T10:15:30.00Z',
  enabled: true,
  deactivationReason: null,
  remote: false,
  planSelected: true
}, {
  organisationId: 7,
  country: COUNTRY.FRANCE,
  fullName: 'Papier Craft',
  registrationNumber: '84230331500019',
  groupId: 7,
  businessLine: 'CLEANING',
  address: {
    addressLine: '119 rue Francis de pressense',
    postCode: '69100',
    city: 'Villeurbanne'
  },
  identificationNumbers: {
    [GROUP_NUMBER_CODE]: '842303315',
    [VAT_IDENTIFICATION_NUMBER_CODE]: 'FR84230331544'
  },
  depositor: true,
  mandateService: true,
  status: true,
  dossierState: 'VALID',
  creationDate: '2018-05-07T10:15:30.00Z',
  enabled: false,
  deactivationReason: 'Deactivated for test purpose',
  remote: true,
  planSelected: true
}];

export const findOrganisation = organisationId => {
  const foundOrganisation = organisationsInDb.find(organisation => organisation.organisationId === organisationId);
  return {...foundOrganisation};
};

export default class FakeOrganisationService {
  get(organisationId) {
    return Promise.resolve(findOrganisation(organisationId));
  }

  getByRegistrationNumberAndCountry(registrationNumber, country) {
    const organisationFound = organisationsInDb
      .find(organisation => (organisation.country === country) && (organisation.registrationNumber === registrationNumber));

    return Promise.resolve(organisationFound);
  }

  getDetails(organisationId) {
    return Promise.resolve(findOrganisation(organisationId));
  }

  getPriorAcceptation(organisationId) {
    return Promise.resolve(findOrganisation(organisationId));
  }

  search(search) {
    const matchingOrganisations = organisationsInDb
      .filter(organisation => organisation.fullName.toLowerCase().startsWith(search.query.toLowerCase()) || organisation.registrationNumber.startsWith(search.query));

    return new Promise(resolve => {
      setTimeout(() => resolve({organisations: matchingOrganisations, totalCount: matchingOrganisations.length}), 0);
    });
  }

  searchByRegistrationNumber(queryRegistrationNumber, country) {
    const matchingOrganisations = organisationsInDb
      .filter(organisation => organisation.country === country)
      .filter(organisation => organisation.registrationNumber.includes(queryRegistrationNumber));

    return Promise.resolve(matchingOrganisations);
  }

  createOrganisation(organisation) {
    const response = {...organisation, organisationId: Number(uniqueId())};
    organisationsInDb.push(response);
    return Promise.resolve(response);
  }

  getDefaultOrganisation(userId, organisationId) {
    return Promise.resolve(findOrganisation(organisationId));
  }

  updatePriorAcceptation(organisationId, priorAcceptation) {
    return Promise.resolve(organisationId, priorAcceptation);
  }

  uploadLogo(organisationId) {
    return Promise.resolve(organisationId);
  }
}
